import moment from 'moment'

// Student name + birthdate validation for the voucher entry (home).
// Extracted verbatim from components/Voucher/index.js so V1 and V2 share ONE
// implementation — including the message-precedence quirks documented in
// MATRIZ_REGRAS_FLUXO_COMPRA.md (V-18..V-25). Do not "fix" behavior here without
// updating the matrix and both flows.
export function validateStudent(rawName, rawBirthdate) {
  let valid = true
  let errorMessage = ''
  const name = (rawName || '').trim()

  if (!name.length) {
    valid = false
    errorMessage = 'Por favor, preencher o nome.'
  }

  if (name.match(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g)) {
    valid = false
    errorMessage = 'O nome não pode conter números'
  }

  if (name.split(' ').length < 2) {
    valid = false
    errorMessage = 'Por favor, preencha o nome completo'
  }

  if (name.split(/\s+/).filter(Boolean).some(part => /^[A-Za-zÀ-ÖØ-öø-ÿ]\.?$/.test(part))) {
    valid = false
    errorMessage = 'Por favor, informe o nome completo sem abreviações'
  }

  const birthdate = (rawBirthdate || '').trim()
  const nameValid = valid

  if (!birthdate.length) {
    valid = false
    if (nameValid) errorMessage = 'Preencha a data de nascimento do aluno'
  } else if (!moment(birthdate, 'DD/MM/YYYY', true).isValid()) {
    valid = false
    if (nameValid) errorMessage = 'Data de nascimento inválida'
  } else if (moment(birthdate, 'DD/MM/YYYY', true).isAfter(moment(), 'day')) {
    valid = false
    if (nameValid) errorMessage = 'A data de nascimento não pode ser futura'
  }

  return { valid, errorMessage }
}
